import React from "react";

import "./Input.css";

export default function InputDate({ title, value, handleChangeDate }) {
  return (
    <div className="input">
      <div className="input-title">{title}</div>

      <div className="input-value">
        <input
          value={value}
          type="datetime-local"
          onChange={(event) => handleChangeDate(event.target.value)}
        />
      </div>
    </div>
  );
}
